module.exports = __webpack_public_path__ + "media/this-is-bretta.a16ead5c.mp4";